export default __webpack_public_path__ + "static/media/2023_Blonder_et_al_2023_Oikos.12ea8af6.pdf";